var map = {
	".": 4574,
	"./": 4574,
	"./assets/nav_back.png": 2223,
	"./assets/nav_back_dark.png": 3624,
	"./index": 4574,
	"./index.css": 8175,
	"./index.tsx": 4574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1167;